export const keyExistsInBoject = (obj: Record<string, any>, key: string) => {
  if (!obj || (typeof obj !== 'object' && !Array.isArray(obj))) {
    return false;
  } else if (obj.hasOwnProperty(key)) {
    return true;
  } else if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      const result: any = keyExistsInBoject(obj[i], key);
      if (result) {
        return result;
      }
    }
  } else {
    for (const k in obj) {
      const result: any = keyExistsInBoject(obj[k], key);
      if (result) {
        return result;
      }
    }
  }

  return false;
};
